import { combineReducers } from "redux";
import OrdersReducer from "./ordersReducer";
import portalDetailsReducer from "./portalDetailsReducer";
import ArtworkReducer from "./artworkReducer";
import CatalogueReducer from "./catalogueReducer";
import MCatalogueReducer from "./mcatalogueReducer";
import QuoteReducer from "./quoteReducer";
import DashboardReducer from "./DashboardReducer";
import cartModulereducer from "./cartModulereducer";
import PaymentReducer from "./paymentReducer";
import OrderDetailReducer from './orderDetailReducer'

const entitiesReducer = combineReducers({
    orders: OrdersReducer,
    orderDetail: OrderDetailReducer,
    portalDetails: portalDetailsReducer,
    artwork: ArtworkReducer,
    catalogue: CatalogueReducer,
    mcatalogue: MCatalogueReducer,
    quote: QuoteReducer,
    dashboard: DashboardReducer,
    cart: cartModulereducer,
    payment: PaymentReducer,
})

export default entitiesReducer;
